import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-900/80 border-t border-slate-700/50 py-3 px-6 text-center backdrop-blur-sm">
      <p className="text-slate-400 text-sm">
        <span className="font-semibold text-slate-300">Creative Infotech</span>
        <span className="mx-2 text-slate-600">|</span>
        <span>2024</span>
        <span className="mx-2 text-slate-600">|</span>
        <span>All rights reserved</span>
      </p>
    </footer>
  );
};

export default Footer;
